/**
 * Sizing for Copilot stat values. A value is sized from its own box (a CSS
 * container), so it leaves 8px each side, and can also fit the box's height,
 * whatever the value or the screen size. Widths are for Roboto 800, measured
 * on the page: digits 0.67em, the point 0.33em. A decimal part is set at half size.
 */

const DIGIT_EM = 0.67;
const POINT_EM = 0.33;
export const DECIMAL_SCALE = 0.5;

/** The whole part and the decimal part (with its point) of a value. */
export const valueParts = (value) => {
  const [whole, decimal] = String(value ?? '0').split('.');
  return { whole, decimal: decimal ? `.${decimal}` : '' };
};

/** The value's width in ems at its whole-part size. */
export const valueEms = (value) => {
  const { whole, decimal } = valueParts(value);
  const decimalEms = decimal ? (POINT_EM + (decimal.length - 1) * DIGIT_EM) * DECIMAL_SCALE : 0;
  return Number((whole.length * DIGIT_EM + decimalEms).toFixed(2));
};

/**
 * A CSS font-size: the largest at which a value `ems` wide fits the box less
 * 8px each side, capped at `maxPx`. With `fitHeight` it must also fit the
 * box's height (a size container).
 */
export const fontSizeForEms = (ems, maxPx, fitHeight = false) => {
  const sizes = [`${maxPx}px`, `calc((100cqi - 16px) / ${ems})`];
  if (fitHeight) sizes.push('calc(100cqb - 6px)');
  return `min(${sizes.join(', ')})`;
};
